import { CommunicationRequest as Communication } from '../../../business/models/dto/rim/communication.request.dto';
import { CounterExpertiseRequest as CounterExpertise } from '../../../business/models/dto/rim/counter-expertise.request.dto';
import { RemarkRequest as RemarkType } from '../../../business/models/dto/rim/remark.request.dto';
import { RimViews } from './model';
import { SigningRequest as Signing } from '../../../business/models/dto/rim/signing.request.dto';
import { TypeCodeTranslation } from '../../../business/models/shared.model';
import { ValueAndCauseRequest as ValueAndCause } from '../../../business/models/dto/rim/value-and-cause.request.dto';
import { VatAndPaymentRequest as VatAndPayment } from '../../../business/models/dto/rim/vat-and-payment.request.dto';
import { RimResponse } from '../../../business/models/dto/rim/rim.response.dto';
import { BusinessValidation } from '../../../business/models/policy-business.model';

export const enum DetailsRimActionTypes {
  FETCH_RIMS_TOTAL = '@@detailsRim/FETCH_RIMS_TOTAL',
  SET_TAB_AS_SAVED = '@@detailsRim/SET_TAB_AS_SAVED',
  CHANGE_VIEW = '@@detailsRim/CHANGE_VIEW',
  CHANGE_VIEW_BASIC = '@@detailsRim/CHANGE_VIEW_BASIC',
  FETCH_RIM = '@@detailsRim/FETCH_RIM',
  FETCH_RIM_SUCCESS = '@@detailsRim/FETCH_RIM_SUCCESS',
  FETCH_RIM_FAIL = '@@detailsRim/FETCH_RIM_FAIL',
  RESET_STATE = '@@detailsRim/RESET_STATE',
  ADD_RIM_LINE = '@@detailsRim/ADD_RIM_LINE',
  REMOVE_RIM_LINE = '@@detailsRim/REMOVE_RIM_LINE',
  UPDATE_VALUES = '@@detailsRim/UPDATE_VALUES',
  FETCH_RIM_LIST = '@@detailsRim/FETCH_RIMS_TOTAL',
  FETCH_RIMS_TOTAL_FAIL = '@@detailsRim/FETCH_RIMS_TOTAL_FAIL',
  FETCH_RIMS_TOTAL_SUCCESS = '@@detailsRim/FETCH_RIMS_TOTAL_SUCCESS',
  FETCH_RIMS_TYPECODES_FAIL = '@@detailsRim/FETCH_RIMS_TYPECODES_FAIL',
  FETCH_RIMS_TYPECODES_SUCCESS = '@@detailsRim/FETCH_RIMS_TYPECODES_SUCCESS',
  SET_RIM_ID = '@@detailsRim/SET_RIM_ID',
  SET_RIM_LOCKED = '@@detailsRim/SET_RIM_LOCKED',
  UPDATE_SIGNING = '@@detailsRim/UPDATE_SIGNING',
  UPDATE_VAT_SUM = '@@detailsRim/UPDATE_VAT_SUM',
  SET_RIM_LINES = '@@detailsRim/SET_RIM_LINES',
  ADD_RIM = '@@detailsRim/ADD_RIM',
  OPEN_DACCA = '@@detailsRim/OPEN_DACCA',
  UPDATE_CURRENT_RIM_LINE = '@@detailsRim/UPDATE_CURRENT_RIM_LINE',
  RIM_LINE_SECTION_CHANGE = '@@detailsRim/RIM_SECTION_CHANGED',
  RIM_LINE_ITEM_CHANGE = '@@detailsRim/RIM_ITEM_CHANGED',
  RIM_LINE_VAT_THRESHOLD_CHANGE = '@@detailsRim/RIM_VAT_THRESHOLD_CHANGED',
  RIM_LINE_VAT_PERCENTAGE_CHANGE = '@@detailsRim/RIM_LINE_VAT_PERCENTAGE_CHANGE',
  RIM_LINE_AMOUNT_CHANGE = '@@detailsRim/RIM_LINE_AMOUNT_CHANGE',
  RIM_LINE_DESCRIPTION_CHANGE = '@@detailsRim/RIM_LINE_DESCRIPTION_CHANGE',
  RIM_LINE_INVOICE_PRESENT_CHANGE = '@@detailsRim/RIM_LINE_INVOICE_PRESENT_CHANGE',
  VALIDATE_RIM = '@@detailsRim/VALIDATE_RIM',
  SET_VALIDATED = '@@detailsRim/SET_VALIDATED',
  SET_CURRENT_TAB_AS_DIRTY = '@@detailsRim/SET_CURRENT_TAB_AS_DIRTY',
  IMPORT_LINES_FROM_DACCA_SUCCESS = '@@detailsRim/IMPORT_LINES_FROM_DACCA_SUCCESS',
  UPDATE_RIM_IBAN = '@@detailsRim/UPDATE_RIM_IBAN',
  UPDATE_RIM_BBAN = '@@detailsRim/UPDATE_RIM_BBAN'
}

export interface RimTotal {
  readonly rimHeaderId: number;
  readonly totalAmount: number;
  readonly locked: boolean;
  readonly rimData: RimResponse;
}

export interface RimLine {
  readonly id: number;
  readonly sequence: number;
  readonly amount: string;
  readonly description: string;
  readonly vatPercentageTC: string;
  readonly vatThresholdTC: string;
  readonly amount80: string;
  readonly invoicePresent: boolean;
  readonly rimSectionTC: string;
  readonly rimItemTC: string;
  readonly deleted: boolean;
  readonly vatEnabled: boolean;
  readonly vatPercentageEnabled: boolean;
  readonly amountEnabled: boolean;
  readonly invoicePresentEnabled: boolean;
  readonly rimItemValuesBySection: TypeCodeTranslation[];
  readonly isImportFromDacca: boolean;
}

export interface RimTab {
  readonly isDirty: boolean;
  readonly isSaved: boolean;
}

export interface RimTypeCodes {
  readonly vatThresholdValues: TypeCodeTranslation[];
  readonly vatPercentageValues: TypeCodeTranslation[];
  readonly rimSectionValues: TypeCodeTranslation[];
  readonly rimItemValues: TypeCodeTranslation[];
  readonly rimStatusList: TypeCodeTranslation[];
}
export interface TabDetails {
  [view: string]: {
    isSaved: boolean;
    isDirty: boolean;
  };
}
export interface DetailsRimState {
  readonly currentView: RimViews;
  readonly previousView: RimViews;
  readonly insuredPersonName: string;
  readonly insuredAddress: string;
  readonly rimHeaderId: number;
  readonly valueAndCause: ValueAndCause;
  readonly vatAndPayment: VatAndPayment;
  readonly counterExpertise: CounterExpertise;
  readonly remark: RemarkType;
  readonly communication: Communication;
  readonly signing: Signing;
  readonly locked: boolean | '';
  readonly rimsTotal: RimTotal[];
  readonly rimLines: RimLine[];
  readonly tabs: RimTab[];
  readonly rimTotalItemsTabs: { [key: string]: TabDetails };
  readonly rimLinesAmountTotal: number;
  readonly rimLinesAmount80Total: number;
  readonly rimTypeCodes: RimTypeCodes;
  readonly currentRimLine: RimLine;
  readonly validated: boolean;
  readonly createdByName: string;
  readonly createdByFirstName: string;
  readonly createdByLastName: string;
  readonly createdByCompany: string;
  readonly createdByCompanyDibCode: string;
  readonly approved?: boolean;
  readonly validations: BusinessValidation[];
}

export interface RimTotalItemsTab {
  [key: string]: TabDetails;
}
